__turbopack_context__.v({
  "bingoDescription": "styles-module-scss-module__H-FRSq__bingoDescription",
  "dark": "styles-module-scss-module__H-FRSq__dark",
  "descriptionFavorite": "styles-module-scss-module__H-FRSq__descriptionFavorite",
  "gameDescription": "styles-module-scss-module__H-FRSq__gameDescription",
  "imageContainer": "styles-module-scss-module__H-FRSq__imageContainer",
  "playGameButton": "styles-module-scss-module__H-FRSq__playGameButton",
});
